import { getWidgetPath } from '../../../../../../validator/form-builder/getWidgetPath.ts';
import { type Widget } from '../../../../Widget.ts';
import { WidgetRepository } from '../../../WidgetRepository.ts';
import { type ITableInputWidgetColumnsContext } from './useTableInputWidgetColumns.tsx';

export interface ITableInputCellRenderProps {
  cellWidget: Widget | null | undefined;
  context: ITableInputWidgetColumnsContext;
}

export function TableInputCellRender(props: ITableInputCellRenderProps) {
  const { cellWidget, context } = props;
  if (!cellWidget) return null;

  const cellWidgetType = WidgetRepository.find(cellWidget?.type);
  if (!cellWidgetType) return null;

  const { options } = context;

  const CellComponent = options.preview
    ? cellWidgetType.previewComponent
    : cellWidgetType.formComponent;

  const widgetFormName = getWidgetPath(cellWidget, context.prefix);

  return (
    <CellComponent
      readonly={context.options.readonly}
      name={options.preview ? undefined : widgetFormName}
      widget={cellWidget}
      preview={options.preview}
      componentLayout={{
        hideHelp: true,
        hideLabel: true,
      }}
    />
  );
}
